export type TestimonialTone = 'amber' | 'violet' | 'teal' | 'sage'

export type Testimonial =
    | { kind: 'photo', name: string, role: string, quote: string, image: string, position?: string }
    | { kind: 'quote', name: string, role: string, quote: string, tone: TestimonialTone }

export const TESTIMONIALS: Array<Testimonial> = [
    {
        kind: 'photo',
        name: 'Hannah Lowe',
        role: 'Garden designer',
        quote: 'Looking at my money used to make my chest tight. Now it is a slow Sunday ritual with tea, and I leave it feeling lighter.',
        image: '/images/voices/hannah.jpg',
        position: 'center 30%'
    },
    {
        kind: 'quote',
        name: 'Ines Carvalho',
        role: 'ICU nurse',
        quote: 'I asked if I could go part-time for a year. Before my shift ended, I had a plan and a monthly target.',
        tone: 'amber'
    },
    {
        kind: 'photo',
        name: 'Walter Briggs',
        role: 'Retired civil engineer',
        quote: 'The AI notices the small things and my advisor helps me weigh the big ones. Between them, nothing slips past me.',
        image: '/images/voices/walter.jpg',
        position: 'center 25%'
    },
    {
        kind: 'quote',
        name: 'Devika Rao',
        role: 'Ceramics studio owner',
        quote: 'It flagged a slow season for the studio six weeks early. That one warning saved my whole summer.',
        tone: 'violet'
    },
    {
        kind: 'photo',
        name: 'Claire Duval',
        role: 'Middle school music teacher',
        quote: 'My card balance felt like a wall. Verdane turned it into small, doable steps, and cheered me through every one.',
        image: '/images/voices/claire.jpg',
        position: 'center 20%'
    },
    {
        kind: 'quote',
        name: 'Jonah Feld',
        role: 'Product designer',
        quote: 'My equity package finally makes sense to me. Five years of guessing, cleared up in a single evening.',
        tone: 'teal'
    },
    {
        kind: 'photo',
        name: 'Theo Brennan',
        role: 'Freelance photographer',
        quote: 'Some months are feast, some are famine. Verdane turns it all into one steady paycheck I can plan on.',
        image: '/images/voices/theo.jpg',
        position: 'center 20%'
    },
    {
        kind: 'quote',
        name: 'Amara and Kofi Mensah',
        role: 'First-time parents',
        quote: "Our daughter's college fund took one quiet evening to set up. Picking her car seat took us longer.",
        tone: 'sage'
    }
]
